/**
 * Simple presentational button for using/exporting assets
 * Handles colors (copy), files (download), and URLs (open)
 */

import React, { useCallback } from "react";
import { Item } from "@thenounproject/lingo-core";
import AssetActionButton, { getUseIcon } from "./AssetActionButton";

type Props = {
  item: Item;
  onClick: (item: Item, e: React.MouseEvent) => void;
  buttonPosition?: "center" | "bottom";
  className?: string;
  position?: "absolute" | "relative" | "static";
};

const UseButton: React.FC<Props> = ({ item, onClick, buttonPosition, className, position }) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      onClick(item, e);
    },
    [item, onClick]
  );

  return (
    <AssetActionButton
      icon={getUseIcon(item.asset)}
      onClick={handleClick}
      buttonPosition={buttonPosition}
      className={className}
      position={position}
    />
  );
};

export default UseButton;
